import React, { useLayoutEffect } from 'react';
import { ThemeProvider as EmotionThemeProvider, CacheProvider as EmotionCacheProvider } from '@emotion/react';
import { theme, originalThemeValues, newThemeValues } from '@frontend/theme-adapter';
import { createPrioritizedEmotionCache } from './emotion-linaria-precedence';
import { setCssProperties } from './set-css-properties';

const emotionCache = createPrioritizedEmotionCache('css');

type AdapterThemeProviderProps = {
  children?: React.ReactNode;
  includeEmotionTheme?: boolean;
  useNewTheme?: boolean;
};

/**
 * An adapter theme to map colors and values from the new theme
 * to the original theme.
 *
 * The adapter theme uses CSS variables to dynamically change
 * the
 *
 * All theme values are backwards compatible with @weave/theme-original.
 */
export const AdapterThemeProvider = ({
  children,
  includeEmotionTheme = false,
  useNewTheme = false,
}: AdapterThemeProviderProps) => {
  useLayoutEffect(() => {
    // Used just for developer experience to know which theme is in use
    document.body.setAttribute('data-theme', useNewTheme ? 'newTheme' : 'originalTheme');

    if (useNewTheme) {
      setCssProperties(newThemeValues);
    } else {
      setCssProperties(originalThemeValues);
    }
  }, [useNewTheme]);

  return (
    <EmotionCacheProvider value={emotionCache}>
      {includeEmotionTheme ? (
        <EmotionThemeProvider theme={theme as any}>{children}</EmotionThemeProvider>
      ) : (
        <>{children}</>
      )}
    </EmotionCacheProvider>
  );
};
